module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "items"
  }, [_c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.items), function(item, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": _vm.getHeaderLabel(item),
        "items": _vm.form.items,
        "errors": _vm.checkForErrors(_vm.errors.items, [i]),
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.form, "items", $event)
        }
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Typ",
        "error": _vm.errors.items && _vm.errors.items[i] && _vm.errors.items[i].item_type
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "Wybierz typ breadcrumba"
      },
      on: {
        "change": function($event) {
          return _vm.typeChanged(item)
        }
      },
      model: {
        value: (item.item_type),
        callback: function($$v) {
          _vm.$set(item, "item_type", $$v)
        },
        expression: "item.item_type"
      }
    }, _vm._l((_vm.types), function(item) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "label": item.label,
          "value": item.value
        }
      })
    }), 1)], 1), _vm._v(" "), (item.item_type) ? _c('el-form-item', {
      attrs: {
        "label": "Tytuł",
        "error": _vm.errors.items && _vm.errors.items[i] && _vm.errors.items[i][_vm.addLanguageSuffix('title')]
      }
    }, [_c('el-input', {
      model: {
        value: (item[_vm.addLanguageSuffix('title')]),
        callback: function($$v) {
          _vm.$set(item, _vm.addLanguageSuffix('title'), $$v)
        },
        expression: "item[addLanguageSuffix('title')]"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.item_type === 'link') ? _c('link-component', {
      key: item.key || item.id,
      attrs: {
        "errors": _vm.errors.items && _vm.errors.items[i] && _vm.errors.items[i]['link']
      },
      model: {
        value: (item.link),
        callback: function($$v) {
          _vm.$set(item, "link", $$v)
        },
        expression: "item.link"
      }
    }) : _vm._e()], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("\n            Dodaj breadcrumb\n        ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0372cbac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/BreadcrumbsWidget.vue
// module id = 710
// module chunks = 0